export default { sha: 'de21be23cba8a99593346286abb390515bcd339e', buildNumber: 'undefined' }
